customerUploadDocs('loa', '_loa');
customerUploadDocs('immat', 'docs-immat');
customerUploadDocs('assurance', '_assurance');

function customerUploadDocs(type, filesPrefix) {
    const upload = document.getElementById(`upload-${type}`);
    const inputFiles = document.querySelectorAll(`[id^=${filesPrefix}]`);
    const msg = document.getElementById(`msg-${type}`);

    if (null !== upload) {
        // Listen to file sizes
        inputFiles.forEach(file => {
            file.addEventListener('change', function () {
                if (file.files[0].size > 15000000) {
                    console.log(file.files[0].size);
                    alert(`La taille maximale de fichier autorisé est de 15MB.`);
                    file.value = '';
                }
            });
        });

        // Listen to upload button
        upload.addEventListener('click', function () {
            let filesUploaded = [];
            msg.innerHTML = '';
            inputFiles.forEach(file => filesUploaded.push(file.files.length));
            if (filesUploaded.every(v => v === 0)) {
                alert(`Veuillez charger au moins un ficher !`);
                return;
            }
            upload.innerText = `Envoi...`;
            let form = new FormData();
            inputFiles.forEach(file => {
                form.append(file.name, file.files[0]);
            });
            form.append('orderId', upload.getAttribute('data-id'));
            form.append('fromClient', '1');
            form.append('g2rNonce', g2rObj.nonces.nonce);
            fetch(`/wp-json/g2r/v1/upload/${type}`, {
                method: 'POST',
                headers: {'X-WP-Nonce': g2rObj.nonces.wp},
                body: form,
            }).then(data => data.json())
                .then(data => {
                    if (data.upload) {
                        console.log(data);
                        upload.innerText = `Fini !`;
                        inputFiles.forEach(file => {
                            if (undefined !== data.names[file.name]) {
                                const link = document.getElementById(`js-${file.name}`);
                                link.innerText = data.names[file.name];
                                link.setAttribute('href', `${data.path}${data.names[file.name]}`);
                            }
                        });
                        setTimeout(() => {
                            msg.innerHTML = `<i class="fa fa-thumbs-up"></i> Nous avons bien reçu vos documents, merci. Nous vous tiendrons informés dans les meilleurs délais.`;
                            upload.innerText = `Envoyer les documents`;
                            inputFiles.forEach(file => file.value = '');
                        }, 2000);
                    } else {
                        alert(`L'upload des fichiers n'a pas pu s'effectuer. Veuillez nous les transmettre par email à shop@go2roues.com.`);
                        inputFiles.forEach(file => file.value = '');
                        upload.innerText = `Envoyer les documents`;
                    }
                })
                .catch(error => {
                    console.error(error);
                    alert(`L'upload des fichiers n'a pas pu s'effectuer. Veuillez nous les transmettre par email à shop@go2roues.com.`);
                });
        });
    }
}
